import React, { useEffect, useState } from "react";
import { notification, Spin } from "antd";
import SectionHeader from "./SectionHeader";
import ScrollCarousel from "./ScrollCarousel";
import DealCard from "./DealCard";
import ExclusiveDealsApi from "../../../../api-services/exclusive-deals-api.service";
import { Deal } from "../../../../interfaces/deal.interface";

const exclusiveDealsApi = new ExclusiveDealsApi();

// "Exclusive Deals" — fixed-width (344px) ticket cards in a native scroll-snap
// track (clamps cleanly at both ends, no trailing empty space). Shows the
// first page of results; the full, paginated list lives at "View all"
// (see ../ExclusiveDealsListing).
export default function ExclusiveDeals() {
  const [deals, setDeals] = useState<Deal[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    exclusiveDealsApi.getDeals(1)
      .then(({ deals }) => setDeals(deals))
      .catch(() => notification.error({ message: "Something went wrong while loading Exclusive Deals." }))
      .finally(() => setLoading(false));
  }, []);

  return (
    <section className="v2-section" id="exclusive-deals-v2">
      <SectionHeader title="Exclusive Deals" subtitle="Limited-time offers you shouldn't miss." viewAllHref="/web/v2/exclusive-deals" />
      <Spin size="large" className="loader" spinning={loading} />
      {!loading && (
        <ScrollCarousel trackClassName="v2-deals__track" step={360}>
          {deals.map((deal) => (
            <DealCard key={deal.id} deal={deal} />
          ))}
        </ScrollCarousel>
      )}
    </section>
  );
}
